var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGames(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76758 14.5664H10.6348",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70117 12.6328V16.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3744_2128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 32.25V0.75H0.75V32.25H32.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3744_2128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2988 12.5273C24.4185 12.5273 24.5156 12.4303 24.5156 12.3105C24.5156 12.1908 24.4185 12.0937 24.2988 12.0937C24.1791 12.0937 24.082 12.1908 24.082 12.3105C24.082 12.4303 24.1791 12.5273 24.2988 12.5273Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2988 17.0391C24.4185 17.0391 24.5156 16.942 24.5156 16.8223C24.5156 16.7025 24.4185 16.6055 24.2988 16.6055C24.1791 16.6055 24.082 16.7025 24.082 16.8223C24.082 16.942 24.1791 17.0391 24.2988 17.0391Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2598 14.5664C22.2598 14.4467 22.1627 14.3496 22.043 14.3496C21.9233 14.3496 21.8262 14.4467 21.8262 14.5664C21.8262 14.6861 21.9233 14.7832 22.043 14.7832C22.1627 14.7832 22.2598 14.6861 22.2598 14.5664Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7715 14.5664C26.7715 14.4467 26.6744 14.3496 26.5547 14.3496C26.435 14.3496 26.3379 14.4467 26.3379 14.5664C26.3379 14.6861 26.435 14.7832 26.5547 14.7832C26.6744 14.7832 26.7715 14.6861 26.7715 14.5664Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5332 14.5664H17.4668",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.918 19.4004C17.918 20.4682 18.7837 21.334 19.8516 21.334C20.9194 21.334 21.7852 20.4682 21.7852 19.4004C21.7852 18.3325 20.9194 17.4668 19.8516 17.4668C18.7837 17.4668 17.918 18.3325 17.918 19.4004Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.082 19.4004C15.082 20.4682 14.2163 21.334 13.1484 21.334C12.0806 21.334 11.2148 20.4682 11.2148 19.4004C11.2148 18.3325 12.0806 17.4668 13.1484 17.4668C14.2163 17.4668 15.082 18.3325 15.082 19.4004Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.0547V4.25391",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0551 19.0781H17.9455",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6972 21.1395L25.0465 27.1638C25.7503 28.123 26.8852 28.7461 28.166 28.7461C30.3018 28.7461 32.0332 27.0147 32.0332 24.8789L31.0346 13.9099C30.7044 10.4804 27.8149 7.79883 24.2988 7.79883C22.2947 7.79883 20.4942 8.6703 19.255 10.0547H13.745C12.5058 8.6703 10.7053 7.79883 8.70117 7.79883C5.18506 7.79883 2.29556 10.4804 1.96537 13.9099L0.966797 24.8789C0.966797 27.0147 2.6982 28.7461 4.83398 28.7461C6.1148 28.7461 7.24962 28.123 7.95339 27.1638L12.3028 21.1395",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2988 7.79883V6.1875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70117 7.79883V6.1875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.9378ce9395f8e1a02cf28b3d72f9c25a.svg";
export { ForwardRef as ReactComponent };